import { useContext } from "react";
import AccessContext from "../AccessContext";

export const useAccessContext = () => {
  const access = useContext(AccessContext);
  return access;
};
